import React from 'react'

const YouTubeIframe = ({ videoId, width, height }) => {
    return (
        <iframe
            title="Video embed"
            width={width}
            height={height}
            src={`https://www.youtube-nocookie.com/embed/${videoId}`}
            frameBorder="0"
            allow="encrypted-media"
            allowFullScreen
        ></iframe>
    )
}

YouTubeIframe.defaultProps = {
    width: '100%',
    height: '100%',
}

export default YouTubeIframe
